import { useEffect } from "react";

import useDocumentTitle from "../../utils/useDocumentTitle";

import { useHistory, useLocation } from "react-router-dom";
import PageContent from "../../components/PageContent";
import SectionTitle from "../../components/SectionTitle";
import { DashboardLayout } from "../../layouts/DashboardLayout";
import styles from "./NoMatch.module.scss";

export function NoMatch(props) {
  useDocumentTitle(props.title);
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const isNewUser = localStorage.getItem("first_login") === "1";

    if (isNewUser) {
      localStorage.setItem("target_path", location.pathname + location.search);
      history.push("/settings/changePassword");
    }
  }, [history, location.pathname, location.search]);

  return (
    <DashboardLayout>
      <div className={styles.pageWrapper}>
        <PageContent indent>
          <SectionTitle>Page Not Found</SectionTitle>
          <span
            style={{ cursor: "pointer" }}
            onClick={e => {
              e.preventDefault();
              history.goBack();
            }}
          >
            Go back
          </span>
        </PageContent>
      </div>
    </DashboardLayout>
  );
}
